import {ScrollView} from 'react-native';

import sy from '~/styles';
import {Text, Dialog} from '~/components/controls';

import WarningIcon from '~/images/md-icons/warning/materialsymbolsoutlined/24px.svg';
import PropTypes from 'prop-types';

const SyncErrorsDialog = ({visible, onDismiss, title, body, errors}) => (
  <Dialog
    visible={visible}
    title={title}
    titleIcon={<WarningIcon height="24px" width="24px" fill="#FF6C00" />}
    buttons={[
      {
        text: 'Sluiten',
        onPress: onDismiss,
      },
    ]}>
    <ScrollView style={[sy['py-4']]} contentContainerStyle={{maxHeight: 400}}>
      <Text style={sy['mb-4']}>{body}</Text>
      {errors?.map((item) => (
        <Text key={item} style={{display: 'list-item', listStyle: 'inside'}}>
          {item}
        </Text>
      ))}
    </ScrollView>
  </Dialog>
);
SyncErrorsDialog.propTypes = {
  visible: PropTypes.any,
  onDismiss: PropTypes.any,
  title: PropTypes.any,
  body: PropTypes.any,
  errors: PropTypes.any,
};

export default SyncErrorsDialog;
